import React from "react";
import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  return (
    <div className="bg-white rounded-sm shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="relative aspect-square overflow-hidden">
        <img
          src={product.image || "/placeholder-image.jpg"}
          alt={product.name}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
        {product.isNewArrival && (
          <span className="absolute top-2 left-2 bg-[#D4AF37] text-white text-xs font-bold px-2 py-1 rounded">
            New Arrival
          </span>
        )}
      </div>
      <div className="p-4">
        <div className="overflow-hidden mb-1">
          <h3 className="text-lg font-medium text-gray-900 whitespace-nowrap animate-marquee hover:animate-none">
            {product.name}
          </h3>
        </div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-lg font-bold text-[#D4AF37]">
            ₹{product.discountedPrice.toFixed(2)}
          </span>
          {product.discount > 0 && (
            <>
              <span className="text-sm text-gray-500 line-through">
                ₹{product.originalPrice.toFixed(2)}
              </span>
              <span className="text-xs bg-red-100 text-red-800 px-1.5 py-0.5 rounded">
                {product.discount}% OFF
              </span>
            </>
          )}
        </div>
        <Link
          to={`/product/${product.id}`}
          className="block w-full text-center bg-[#D4AF37] text-black px-4 py-2 rounded-sm text-sm font-medium hover:bg-[#C19B2E] transition-all duration-200"
        >
          More Details
        </Link>
      </div>
      
      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        
        .animate-marquee {
          animation: marquee 10s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default ProductCard;